export default __webpack_public_path__ + "static/char-s-sp03-ja-34f3d666c5f6d2045a734d3477e3733e.webp";